import { User, UserRole } from '../types';

// Teacher is a subset of User with role='teacher'
export interface Teacher extends Omit<User, 'role'> {
  role: UserRole.TEACHER;
}

// Teachers list parameters - aligned with backend auth/users endpoint
export interface TeachersListParams {
  skip?: number;
  limit?: number;
  search?: string;
  school_id?: number;
  district_id?: number;
  role?: string; // Always 'teacher' for this service
  is_active?: boolean;
}

// Get teachers list - filters users by teacher role
export const getTeachers = async (
  params: TeachersListParams = {}
): Promise<Teacher[]> => {
  try {
    // Use the usersService with role filter
    const { getUsers } = await import('./usersService');
    const response = await getUsers({
      ...params,
      role: UserRole.TEACHER,
    });
    return response.data.filter(
      (user): user is Teacher => user.role === UserRole.TEACHER
    );
  } catch (error) {
    console.error('Get teachers error:', error);
    throw error;
  }
};

// Get teacher by ID - uses the user endpoint
export const getTeacher = async (teacherId: string): Promise<Teacher> => {
  try {
    // Use the usersService
    const { getUser } = await import('./usersService');
    const user = await getUser(parseInt(teacherId, 10));
    if (user.role !== UserRole.TEACHER) {
      throw new Error(`User ${teacherId} is not a teacher`);
    }
    return user as Teacher;
  } catch (error) {
    console.error('Get teacher error:', error);
    throw error;
  }
};

// Export service object
export const teachersService = {
  getTeachers,
  getTeacher,
};
